module.exports = __webpack_public_path__ + "static/media/animated-drag-right.57d9e8a2.gif";